/* eslint-disable */
import { createSelector } from 'reselect';

import ggRouter from 'ggApp/modules/router';

import { CONTENTFUL_MODULE_NAME } from '../constants';
import { isContentfulPage } from '../../utils';

export const moduleState = (state) => state[CONTENTFUL_MODULE_NAME];

export const contentfulPages = createSelector(moduleState, (moduleState) => moduleState.pages);

/**
 * contentfulPage
 * This selectors gets page class
 * or function that returns page type and
 * returns page data from the store.
 * @param {(PageClass|function)} getPageType
 * @example
 * // getPageType as a function has the following structure:
 * function getPageType(reduxStore) {
 *     // ... some actions to get page type class
 *     return pageType;
 * }
 */
export const contentfulPage = (getPageType) => {
    if (isContentfulPage(getPageType)) {
        const pageType = getPageType;

        return createSelector(
            contentfulPages,
            (contentfulPages) => contentfulPages[pageType.pageName],
        );
    }

    return createSelector(
        contentfulPages,
        getPageType,
        (contentfulPages, pageType) => contentfulPages[pageType.pageName],
    );
};
